﻿export * from './core';
export * from './helpers/index'
export * from './com';
export * from './ctrls';

import { WrapperGS, GS } from './core';
import * as comLib from './com';
import * as ctrlsLib from './ctrls';
import * as helpersLib from './helpers/index'

export const com = comLib;
export const ctrls = ctrlsLib;
export const helpers = helpersLib;

/**
* Wrap element in WrapperGs
* @param el
*/
export function w(el: WrapperGS): WrapperGS;
export function w(el: HTMLElement): WrapperGS;
export function w(el: unknown): WrapperGS | undefined;
export function w(el: unknown): WrapperGS | undefined { return WrapperGS.Wrap(el); }
export function q(selector: any) { return GS.Query(selector); }
